/*
  Quick JS by Jason @ freakdesign.
  Adaptado para Prestige + Frenet
*/

(function () {
  "use strict";

  /* Debug opcional */
  var debug = false;
  var cartCookie;

  /* Elemento onde o módulo de frete será inserido */
  var productSection = document.getElementsByClassName("frete-produto");
  if (!productSection.length) {
    log("Could not find the element .frete-produto");
    return;
  }

  /* Select / input principal de variante */
  var productSelect = document.getElementById("ProductSelect-product-template");
  if (!productSelect) {
    productSelect = document.getElementsByName("id")[0];
  }
  if (!productSelect) {
    log("Could not find the main select element (variant id)");
    return;
  }

  /* Campos criados via JS */
  var shippingMessage = document.createElement("p");
  var shippingCountry = document.createElement("select");
  var shippingProvince = document.createElement("select");
  var shippingZip = document.createElement("input");
  var freteLista = document.createElement("div");

  /* Ajustes da lista de fretes */
  freteLista.classList.add("listas-de-fretes");
  freteLista.setAttribute("style", "display:none");

  var countVariable = 1;
  var qtdVariants = jQuery(productSelect).find("option").length;

  /* Cria os campos do simulador */
  var initFields = function () {
    /* Country */
    shippingCountry.id = "pais-simulator";
    var countries = ["Brazil"];
    for (var i = 0; i < countries.length; i++) {
      shippingCountry.add(new Option(countries[i], countries[i], i === 0));
    }
    shippingCountry.name = "shipping_address[country]";

    /* Province */
    shippingProvince.id = "estados-simulator";
    var provinces = [
      "Acre",
      "Alagoas",
      "Amapa",
      "Amazonas",
      "Bahia",
      "Ceara",
      "Distrito Federal",
      "Espirito Santo",
      "Goias",
      "Maranhao",
      "Mato Grosso",
      "Mato Grosso do Sul",
      "Minas Gerais",
      "Para",
      "Paraiba",
      "Parana",
      "Pernambuco",
      "Piaui",
      "Rio de Janeiro",
      "Rio Grande do Norte",
      "Rio Grande do Sul",
      "Rondonia",
      "Roraima",
      "Santa Catarina",
      "Sao Paulo",
      "Sergipe",
      "Tocantins",
    ];
    for (var j = 0; j < provinces.length; j++) {
      shippingProvince.add(new Option(provinces[j], provinces[j], j === 0));
    }
    shippingProvince.name = "shipping_address[province]";

    /* CEP */
    shippingZip.type = "text";
    shippingZip.name = "shipping_address[zip]";
    shippingZip.placeholder = "Digite seu CEP";

    /* Wrapper */
    var shippingCalcWrapper = document.createElement("div");
    shippingCalcWrapper.className = "shipping-calc-wrapper";

    /* Botão calcular */
    var shippingCalcButton = document.createElement("button");
    shippingCalcButton.innerText = "Calcular";
    shippingCalcButton.className = "btn";
    shippingCalcButton.type = "button";

    shippingCalcButton.onclick = function () {
      var cepLimpo = shippingZip.value.replace(/\D/g, "");

      jQuery.getJSON(
        "https://viacep.com.br/ws/" + cepLimpo + "/json/?callback=?",
        function (dados) {
          if (!("erro" in dados)) {
            /* Mapeia UF sigla -> nome usado na Shopify */
            switch (dados.uf) {
              case "AC":
                dados.uf = "Acre";
                break;
              case "AL":
                dados.uf = "Alagoas";
                break;
              case "AP":
                dados.uf = "Amapa";
                break;
              case "AM":
                dados.uf = "Amazonas";
                break;
              case "BA":
                dados.uf = "Bahia";
                break;
              case "CE":
                dados.uf = "Ceara";
                break;
              case "DF":
                dados.uf = "Distrito Federal";
                break;
              case "ES":
                dados.uf = "Espirito Santo";
                break;
              case "GO":
                dados.uf = "Goias";
                break;
              case "MA":
                dados.uf = "Maranhao";
                break;
              case "MT":
                dados.uf = "Mato Grosso";
                break;
              case "MS":
                dados.uf = "Mato Grosso do Sul";
                break;
              case "MG":
                dados.uf = "Minas Gerais";
                break;
              case "PA":
                dados.uf = "Para";
                break;
              case "PB":
                dados.uf = "Paraiba";
                break;
              case "PR":
                dados.uf = "Parana";
                break;
              case "PE":
                dados.uf = "Pernambuco";
                break;
              case "PI":
                dados.uf = "Piaui";
                break;
              case "RJ":
                dados.uf = "Rio de Janeiro";
                break;
              case "RN":
                dados.uf = "Rio Grande do Norte";
                break;
              case "RS":
                dados.uf = "Rio Grande do Sul";
                break;
              case "RO":
                dados.uf = "Rondonia";
                break;
              case "RR":
                dados.uf = "Roraima";
                break;
              case "SC":
                dados.uf = "Santa Catarina";
                break;
              case "SP":
                dados.uf = "Sao Paulo";
                break;
              case "SE":
                dados.uf = "Sergipe";
                break;
              case "TO":
                dados.uf = "Tocantins";
                break;
            }

            shippingProvince.value = dados.uf;

            cartCookie = getCookie("cart");
            var tempCookieValue =
              window.tempCookieValue || "temp-cart-cookie___" + Date.now();
            var fakeCookieValue =
              window.fakeCookieValue || "fake-cart-cookie___" + Date.now();

            /* se não tiver cookie ainda, cria um temporário */
            if (!cartCookie) {
              log("no cookie found");
              updateCartCookie(tempCookieValue);
              cartCookie = getCookie("cart");
            } else {
              log("cookie found");
            }

            if (cartCookie.length < 32) {
              log("cart ID not valid");
              return;
            }

            /* muda para cookie fake pra não sujar carrinho real */
            updateCartCookie(fakeCookieValue);
            log(getCookie("cart"));

            /* se nenhuma variação selecionada, tenta pegar a primeira disponível */
            if (!productSelect.value.length) {
              var idVariantFind;
              for (var i = 0; i < qtdVariants; i++) {
                var opt = jQuery(productSelect).find("option").get(i);
                if (
                  opt &&
                  opt.text.indexOf("Esgotado") === -1 &&
                  opt.text.indexOf("Selecione") === -1
                ) {
                  idVariantFind = parseInt(opt.value, 10);
                  getRates(idVariantFind, cepLimpo);
                  return;
                } else {
                  countVariable++;
                }
              }
            } else {
              getRates(parseInt(productSelect.value, 10), cepLimpo);
            }
          }
        }
      );

      return false;
    };

    /* Monta wrapper */
    shippingCalcWrapper.appendChild(shippingCountry);
    shippingCalcWrapper.appendChild(shippingProvince);
    shippingCalcWrapper.appendChild(shippingZip);
    shippingCalcWrapper.appendChild(shippingCalcButton);
    shippingCalcWrapper.appendChild(shippingMessage);
    shippingCalcWrapper.appendChild(freteLista);

    /* Adiciona ao bloco .frete-produto */
    productSection[0].appendChild(shippingCalcWrapper);
  };

  /* Console log condicional */
  var log = function (a) {
    if (!debug) {
      return;
    }
    console.log(a);
  };

  /* Cookie helpers */
  var getCookie = function (name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  };

  var updateCartCookie = function (a) {
    log("changing cart cookie value to: " + a);
    var date = new Date();
    date.setTime(date.getTime() + 14 * 86400000);
    var expires = "; expires=" + date.toGMTString();
    document.cookie = "cart=" + a + expires + "; path=/";
  };

  var resetCartCookie = function () {
    if (!cartCookie) return;
    updateCartCookie(cartCookie);
    log(getCookie("cart"));
  };

  /* helper pra formatar dinheiro caso Shopify.formatMoney não exista */
  var safeFormatMoney = function (valorFrete) {
    // Se tiver Shopify.formatMoney, usa ele
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(valorFrete, window.money_format);
    }

    // senão, tenta converter e formatar na mão
    var num = 0;

    if (typeof valorFrete === "string") {
      // "18.47" -> 18.47
      num = parseFloat(valorFrete.replace(",", "."));
    } else {
      // se vier em centavos (número), transforma
      num = valorFrete / 100;
    }

    if (isNaN(num)) {
      return "R$ 0,00";
    }

    return "R$ " + num.toFixed(2).replace(".", ",");
  };

  /* Busca tarifas de frete a partir da variant */
  var getRates = function (variantId, cepLimpo) {
    log("variantId: " + variantId);
    jQuery(".listas-de-fretes").html("").show();

    if (typeof variantId === "undefined" || !variantId) return;

    /* quantidade */
    var productQuantity = document.getElementById("Quantity");
    var quantity = productQuantity ? parseInt(productQuantity.value, 10) : 1;
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    var addData = {
      id: variantId,
      quantity: quantity,
    };

    // Adiciona item no carrinho "fake"
    fetch("/cart/add.js?delivery_internal=true", {
      body: JSON.stringify(addData),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        // Depois de adicionar, consulta as tarifas
        jQuery.ajax({
          type: "GET",
          url: "/cart/shipping_rates.json",
          data: {
            "shipping_address[country]": shippingCountry.value,
            "shipping_address[province]": shippingProvince.value,
            "shipping_address[zip]": cepLimpo || shippingZip.value,
          },
          dataType: "json",

          beforeSend: function () {
            jQuery(".listas-de-fretes")
              .show()
              .html("Carregando fretes...");
          },

          success: function (d) {
            jQuery(".listas-de-fretes").show().html("");

            if (d.shipping_rates && d.shipping_rates.length) {
              for (var i = 0; i < d.shipping_rates.length; i++) {
                var rate = d.shipping_rates[i];

                // Preço formatado
                var valorFrete = rate.price;
                if (
                  valorFrete === "0.00" ||
                  valorFrete === null ||
                  valorFrete === 0
                ) {
                  valorFrete = "<b style='color:#267c59;'>Grátis</b>";
                } else {
                  valorFrete = safeFormatMoney(valorFrete);
                }

                // Dias úteis (se existirem)
                var dias = "";
                if (rate.delivery_days) {
                  dias =
                    rate.delivery_days[1] ||
                    rate.delivery_days[0] ||
                    "";
                }
                var estimativaTexto = dias
                  ? "(Em até " + dias + " dias úteis)"
                  : "";

                var html =
                  '<div class="frete-item">' +
                  "<div>" +
                  '<p class="m-0 nome-frete">' +
                  "<b>" +
                  rate.name +
                  "</b> " +
                  '<span class="estimativa-de-entrega">' +
                  estimativaTexto +
                  "</span>" +
                  "</p>" +
                  "</div>" +
                  '<div class="frete-valor">' +
                  valorFrete +
                  "</div>" +
                  "</div>";

                jQuery(".listas-de-fretes").append(html);
              }
            } else {
              jQuery(".listas-de-fretes").html(
                "Nenhuma opção de frete encontrada para esse CEP."
              );
            }

            resetCartCookie();
          },

          error: function () {
            resetCartCookie();
            shippingMessage.innerHTML =
              "Erro ao calcular o frete. Tente novamente.";
            jQuery(".listas-de-fretes").hide().html("");
          },
        });
      })
      .catch(function (err) {
        console.error(err);
        resetCartCookie();
      });
  };

  /* Inicializa campos ao carregar o script */
  initFields();
})();
